<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Order No：{{ formData.orderNo ? formData.orderNo : 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.orderStatus === 'Y' ||
            formData.orderStatus === 'P' ||
            formData.orderStatus === 'C'
              ? 'success'
              : formData.orderStatus === 'S'
              ? 'warning'
              : formData.orderStatus === 'D' ||
                formData.orderStatus === 'R' ||
                formData.orderStatus === 'T'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_orderStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyTime ? formData.modifyTime : '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_salesPersonCode') || '业务人员'"
            prop="salesPersonCode"
          >
            <dict-select
              clearable
              v-model="formData.salesPersonCode"
              filterable
              url="/master/common/dict/baseUserSelect"
              :placeholder="
                $l('INDEX.form_label_please_select_a_business_person') ||
                  '请选择业务人员'
              "
              :selectedLabel.sync="formData.salesPersonName"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_bizPersonCode') || '跟单人员'"
            prop="bizPersonCode"
          >
            <dict-select
              clearable
              v-model="formData.bizPersonCode"
              filterable
              url="/master/common/dict/baseUserSelect"
              :placeholder="
                $l('INDEX.tips_select_bizPersonCode') || '请选择跟单人员'
              "
              :selectedLabel.sync="formData.bizPersonName"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderType') || '订单类型'"
            prop="orderType"
          >
            <dict-select
              clearable
              filterable
              v-model="formData.orderType"
              :body="orderTypeParams"
              url="/sys/common/dict/system"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderSource') || '订单来源'"
            prop="orderSource"
          >
            <dict-select
              clearable
              filterable
              v-model="formData.orderSource"
              :body="orderSourceTypeParams"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_issueType') || '下单方式'"
            prop="issueType"
          >
            <dict-select
              clearable
              filterable
              v-model="formData.issueType"
              :body="issueTypeParams"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_salesSeason') || '销售季节'"
          >
            <dict-select
              clearable
              filterable
              v-model="formData.salesSeason"
              :body="salesSeasonParams"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_custCode') || '下单客户'"
            prop="custCode"
          >
            <dict-select
              clearable
              filterable
              v-model="formData.custCode"
              url="/digitalCenter/common/dict/customer"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_custOrderNo') || '客户订单编号'"
            prop="custOrderNo"
          >
            <el-input
              v-model="formData.custOrderNo"
              type="text"
              maxlength="50"
              show-word-limit
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.order_form_label_identifyNo') || '识别单号'"
          >
            <identify-input
              ref="identify"
              size="small"
              :disabled="disabled"
              :identifyNo.sync="formData.identifyNo"
              :identifyJson.sync="formData.identifyJson"
            >
            </identify-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_customerComfirmTime') || '客户下单日期'
            "
            prop="customerComfirmTime"
          >
            <el-date-picker
              style="width:100%"
              value-format="yyyy-MM-dd"
              clearable
              v-model="formData.customerComfirmTime"
              type="date"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_endCustCode') || '终端客户'"
            prop="endCustCode"
          >
            <dict-select
              clearable
              filterable
              v-model="formData.endCustCode"
              url="/digitalCenter/common/dict/customer"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_label_brand') || '品牌'">
            <dict-select
              clearable
              v-model="formData.brandCode"
              filterable
              url="/master/common/dict/brandSelect"
              :placeholder="
                $l('INDEX.form_label_please_select_brand') || '请选择品牌'
              "
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_brandDepartment') || '品牌方部门'
            "
          >
            <el-input
              v-model="formData.brandDepartment"
              clearable
              maxlength="50"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_deliveryDay') || '交货日期'"
            prop="deliveryDay"
          >
            <el-date-picker
              style="width:100%"
              value-format="yyyy-MM-dd"
              clearable
              v-model="formData.deliveryDay"
              type="date"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_shipmentType') || '出运方式'"
          >
            <dict-select
              clearable
              filterable
              v-model="formData.shipmentType"
              :body="shipmentTypeParams"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_deliveryPort') || '交货港口'"
          >
            <dict-select
              clearable
              filterable
              v-model="formData.deliveryPort"
              url="/master/port/select"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('INDEX.order_form_label_deliveryAddress') || '交货地址'"
          >
            <el-input
              v-model="formData.deliveryAddress"
              clearable
              maxlength="1000"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.order_form_label_quotedMethod') || '报价方式'"
            prop="quotedMethod"
          >
            <dict-select
              clearable
              filterable
              v-model="formData.quotedMethod"
              :body="quotedMethodParams"
              url="/sys/common/dict/system"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_Total_order_cost') || '订单成本总价'
            "
          >
            <el-input v-model="formData.v_orderAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.order_form_label_currencyUnit') || '成本货币单位'"
            prop="currencyUnit"
          >
            <dict-select
              clearable
              filterable
              v-model="formData.currencyUnit"
              :body="currencyUnitParams"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_Total_order_selling_price') ||
                '订单售价合计'
            "
          >
            <el-input v-model="formData.v_orderSalesAmount" readonly>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_salesCurrencyUnit') || '售价货币单位'
            "
            prop="salesCurrencyUnit"
          >
            <dict-select
              clearable
              filterable
              v-model="formData.salesCurrencyUnit"
              :body="currencyUnitParams"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="$l('INDEX.order_form_label_paymentTerms') || '客户付款条件'"
            prop="paymentTerms"
          >
            <dict-select
              clearable
              filterable
              v-model="formData.paymentTerms"
              :body="paymentTermsParams"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.order_form_label_importanceLevel') || '订单性质'"
            prop="importanceLevel"
          >
            <dict-select
              clearable
              filterable
              v-model="formData.importanceLevel"
              :body="importanceLevelParams"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderExecuteType') || '执行方式'"
            prop="orderExecuteType"
          >
            <dict-select
              clearable
              filterable
              v-model="formData.orderExecuteType"
              :body="orderExecuteTypeParams"
              url="/sys/common/dict/system"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="$l('INDEX.order_form_label_scmCode') || '执行工厂'"
            prop="scmCode"
          >
            <dict-select
              v-model="formData.scmCode"
              clearable
              filterable
              url="/master/common/dict/scmPartners"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_factoryPaymentTerms') || '工厂付款条件'
            "
            prop="factoryPaymentTerms"
          >
            <dict-select
              clearable
              filterable
              v-model="formData.factoryPaymentTerms"
              :body="paymentTermsParams"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderScmCode') || '名义工厂'"
            prop="orderScmCode"
          >
            <dict-select
              v-model="formData.orderScmCode"
              clearable
              filterable
              url="/master/common/dict/scmPartners"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_settlementFactory') || '结算工厂'
            "
            prop="settlementFactory"
          >
            <dict-select
              v-model="formData.settlementFactory"
              clearable
              filterable
              url="/master/common/dict/scmPartners"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_exchangeRate') ||
                '下单汇率(1外币兑换人民币)'
            "
            prop="exchangeRate"
          >
            <el-input-number
              v-model="formData.exchangeRate"
              controls-position="right"
              style="width:100%"
              :precision="5"
              :max="999999"
              :min="0"
              :step="0.01"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_commissionType') || '佣金计算方式'
            "
            prop="commissionType"
          >
            <el-select
              v-model="formData.commissionType"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in commissionTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_commissionRate') || '佣金比例(%)'
            "
          >
            <el-input-number
              v-model="formData.commissionRate"
              controls-position="right"
              style="width:100%"
              :precision="2"
              :max="100"
              :min="0"
              :step="0.01"
              :disabled="formData.commissionType == 'B'"
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_commissionAmount') || '实际佣金'"
          >
            <el-input v-model="formData.commissionAmount" readonly> </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_invoiceAmount') || '开票金额'"
          >
            <el-input v-model="formData.invoiceAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_importanceLevelDesc') || '订单性质说明'
            "
          >
            <el-input
              v-model="formData.importanceLevelDesc"
              type="textarea"
              rows="4"
              maxlength="1000"
              show-word-limit
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderRemark') || '订单备注说明'"
          >
            <el-input
              v-model="formData.orderRemark"
              type="textarea"
              rows="4"
              maxlength="1000"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex mt-2">
      <div class="side-frame-warning"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Create：{{ formData.createByName || '--' }} at
          {{ formData.createTime || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Submit：{{ formData.submitByName || '--' }} at
          {{ formData.submitTime || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Review：{{ formData.reviewByName || '--' }} at
          {{ formData.reviewTime || '--' }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import dayjs from '@/libs/util.date'
export default {
  components: {},
  mixins: [EditLoading],
  props: {
    changeOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      orderTypeParams: { dictType: 'orderType' },
      issueTypeParams: { dictType: 'issueType' },
      orderSourceTypeParams: { dictType: 'orderSource' },
      orderExecuteTypeParams: { dictType: 'orderExecuteType' },
      quotedMethodParams: { dictType: 'quotedMethod' },
      paymentTermsParams: { dictType: 'paymentTerms' },
      currencyUnitParams: { dictType: 'currencyUnit' },
      shipmentTypeParams: { dictType: 'shipmentType' },
      importanceLevelParams: { dictType: 'importanceLevel' },
      salesSeasonParams: { dictType: 'salesSeason' },
      productLineParams: { dictType: 'productLine' },
      commissionTypeOptions: [
        {
          label: '按佣金百分比计算',
          value: 'A',
        },
        {
          label: '按产品去佣金单价计算',
          value: 'B',
        },
      ],
      formData: {
        customerNotificationTime: dayjs(new Date()).format(
          'YYYY-MM-DD HH:mm:ss'
        ),
        orderStatus: 'N',
        commissionType: 'A',
        identifyJson: '',
        identifyNo: '',
      },
      rules: {
        salesPersonCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_please_select_a_business_person') ||
              '请选择业务人员',
            trigger: ' blur',
          },
        ],
        bizPersonCode: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_select_bizPersonCode') || '请选择跟单人员',
            trigger: ' blur',
          },
        ],
        custOrderNo: [
          {
            required: true,
            message:
              this.$l('INDEX.order_tips_input_custOrderNo') ||
              '请输入客户订单编号',
            trigger: ' blur',
          },
        ],
        custCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_customer') || '请选择客户',
            trigger: ' blur',
          },
        ],
        orderType: [
          {
            required: true,
            message:
              this.$l('INDEX.order_tips_select_orderType') || '请选择订单类型',
            trigger: ' blur',
          },
        ],
        orderSource: [
          {
            required: true,
            message:
              this.$l('INDEX.order_tips_select_orderSource') ||
              '请选择订单来源',
            trigger: ' blur',
          },
        ],
        customerComfirmTime: [
          {
            required: true,
            message:
              this.$l('INDEX.order_tips_select_customer_orderDate') ||
              '请选择客户下单日期',
            trigger: ' blur',
          },
        ],
        deliveryDay: [
          {
            required: true,
            message:
              this.$l('INDEX.order_tips_select_deliveryDay') ||
              '请选择交货日期',
            trigger: ' blur',
          },
        ],
        paymentTerms: [
          {
            required: true,
            message:
              this.$l('INDEX.order_tips_select_payment_terms') ||
              '请选择付款条件',
            trigger: 'change',
          },
        ],
        factoryPaymentTerms: [
          {
            required: true,
            message:
              this.$l('INDEX.order_tips_select_payment_terms') ||
              '请选择付款条件',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        salesCurrencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        importanceLevel: [
          {
            required: true,
            message:
              this.$l('INDEX.order_tips_select_importanceLevel') ||
              '请选择订单性质',
            trigger: 'change',
          },
        ],
        orderExecuteType: [
          {
            required: true,
            message:
              this.$l('INDEX.order_tips_select_orderExecuteType') ||
              '请选择执行方式',
            trigger: 'change',
          },
        ],
        quotedMethod: [
          {
            required: true,
            message:
              this.$l('INDEX.sample_tips_select_quotation_method') ||
              '请选择报价方式',
            trigger: 'change',
          },
        ],
        scmCode: [
          {
            required: true,
            message:
              this.$l('INDEX.order_tips_select_scmCode') || '请选择执行工厂',
            trigger: ' blur',
          },
        ],
        settlementFactory: [
          {
            required: true,
            message:
              this.$l('INDEX.order_tips_select_settlementFactory') ||
              '请选择结算工厂',
            trigger: ' blur',
          },
        ],
        exchangeRate: [
          {
            required: true,
            message:
              this.$l('INDEX.order_tips_form_label_exchangeRate') ||
              '请输入下单汇率',
            trigger: 'blur',
          },
        ],
        commissionType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        orderScmCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_orderScmCode') || '请选择名义工厂',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.formData = {
        customerNotificationTime: dayjs(new Date()).format(
          'YYYY-MM-DD HH:mm:ss'
        ),
        orderStatus: 'N',
        commissionType: 'A',
        identifyJson: '',
        identifyNo: '',
      }
      if (!this.changeOrderCode) return
      this.$api
        .changeOrderInfoDetailApi({
          changeOrderCode: this.changeOrderCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      if (!this.formData.exchangeRate) {
        if (this.formData.orderType === 'domesticTrade')
          this.formData.exchangeRate = 1
      }
      const result = await validate.formValidate([this.$refs.form])
      if (!result)
        return this.$message.error(
          this.$l('INDEX.form_label_any_required_fields_are_not_filled_in') ||
            '有必输字段未填写，请检查'
        )

      this.loadingOpen()
      let saveApi = {}
      saveApi = this.$api.changeOrderInfoEditApi(this.formData)
      saveApi
        .then(async (res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.getData()
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    //产品更新时调用该方法,更新订单的部分字段
    reloadOrderInfo() {
      if (!this.changeOrderCode) return
      this.$api
        .changeOrderInfoPartDetailApi({
          changeOrderCode: this.changeOrderCode,
        })
        .then((res) => {
          const {
            v_orderAmount,
            v_orderSalesAmount,
            commissionRate,
            commissionAmount,
            invoiceAmount,
            commissionType,
          } = res.body
          this.formData.v_orderAmount = v_orderAmount
          this.formData.v_orderSalesAmount = v_orderSalesAmount
          this.formData.commissionRate = commissionRate
          this.formData.commissionAmount = commissionAmount
          this.formData.invoiceAmount = invoiceAmount
          this.formData.commissionType = commissionType
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
